import { Deserializable } from '../protocols/deserializable';
import { Attachment } from '../submissions/attachment';

export class MemberContribution implements Deserializable {
  public id!: number;
  public idPrefix!: string;
  public memberId!: number;
  public contributionTypeId!: number;
  public amount!: number;
  public note!: string | null;
  public paymentMethodTypeId!: number;
  public paymentMethod!: string | null;
  public creditCardId!: number | null;
  public cardType!: string | null;
  public lastFourDigits!: string | null;
  public bankAccountId!: number | null;
  public spouseId!: number | null;
  public createdDate!: string;
  public attachment!: Attachment | null;

  onDeserialize(): void {
    if (this.attachment) {
      this.attachment = window?.injector?.Deserialize?.instanceOf(Attachment, this.attachment);
    }
  }
}
